// @vendors
const { connect } = require('react-redux');
// @actions
const chatActions = require('actions/chat');
// @components
const ChatBar = require('./ChatBar');

const mapStateToProps = (state) => ({
    conversationStatus: state.okChat.get('conversationStatus'),
    chatAvailabilityStatusData: state.okChat.get('chatAvailabilityStatusData'),
    msgReceiveFail : state.okChat.get('msgReceiveFail'),
    showCloseQuestion: state.okChat.get('showCloseQuestion'),
    timer: state.okChat.get('timer')
});

const mapDispatchToProps = ({
    closeWindowAsk: chatActions.closeWindowAsk,
    closeWindowCancel: chatActions.closeWindowCancel,
    closeWindowConfirm: chatActions.closeWindowConfirm,
    disconnectNotice: chatActions.disconnectNotice,
    endConversation: chatActions.endConversation,
    retrieveMessages: chatActions.retrieveMessages,
    startConversation: chatActions.startConversation,
    toggleWindow: chatActions.toggleWindow
});

const ChatBarContainer = connect(mapStateToProps, mapDispatchToProps)(ChatBar);

module.exports = ChatBarContainer;